import numeral from "numeral";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { CardHeadgray, CardMain } from "../../../components/card/CardMain";
import { InfoDrawer } from "../../../components/drawer/InfoDrawer";
import ErrorMain from "../../../components/error/Error.Main";
import { SliderSingle } from "../../../components/slider/SliderSingle";
import { cn } from "../../../utils/useFunctions";
import {
  STYLE_INPUT,
  STYLE_INPUT_ERROR,
  STYLE_INPUT_SLIDER,
  STYLE_SPACE_Y,
} from "../../../utils/useStyle";
import { ViewTableDebt } from "../../debt/component/VIDebtTable";
import { CardKidsSection } from "../../report/view/report.v.education";
import { QuestionCard } from "../../risk_plan/styles/TestCard.Main";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";

export const OutcomeInfo = ({ openCurrent, setOpenCurrent }) => {
  return (
    <InfoDrawer
      open={openCurrent}
      onClose={() => setOpenCurrent(false)}
      head={"รายจ่ายปัจจุบัน (บาท/เดือน)"}
      text={
        " รายจ่ายปัจจุบันต่อเดือน งบประมาณการใช้จ่ายต่อเดือน หรือ เงินเดือนที่หักลบค่าใช้จ่ายประจำ โดยคิดเฉลี่ยเป็นต่อเดือน โดยเฉลี่ยอยู่ที่ 80% ของรายรับ "
      }
    />
  );
};
export const OutcomePerYear = ({ openOutCome, setOpenOutCome }) => {
  return (
    <InfoDrawer
      open={openOutCome}
      onClose={() => setOpenOutCome(false)}
      head={"รายจ่ายที่เพิ่มขึ้นต่อปี (%)"}
      text={
        " รายจ่ายปัจจุบันต่อเดือน งบประมาณการใช้จ่ายต่อปี หรือ เงินเดือนที่หักลบค่าใช้จ่ายประจำ โดยคิดเฉลี่ยเป็นต่อปี โดยเฉลี่ยอยู่ที่ 3-5% "
      }
    />
  );
};

const ViewIncomeOutcome = ({
  onClickCurrentExpenses,
  onClickOutComeperYear,
  formRetire,
  userData,
  balanceData,
  setFormRetire,
  error,
  setError,
  setOpenCurrent,
  setOpenOutCome,
  educationData,
  setRetireData,
}) => {
  // const [ishavekids, setIshavekids] = useState("");
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const setFuturePlanData = useFuturePlanStore(
    (state) => state.setFuturePlanData
  );

  const onChangeOutCome = (field) => (e) => {
    const value = e.target.value;

    let output = parseFloat(value?.replace(/,/g, ""))
      ? parseFloat(value?.replace(/,/g, ""))
      : null;

    if (isNaN(output)) return;
    else {
      setError({
        ...error,
        [field]: false,
      });
    }

    setFormRetire({
      ...formRetire,
      [field]: output,
    });

    if (field === "out_come") {
      setFuturePlanData({
        ...futurePlanData,
        out_come_stable: output,
      });
    }

    if (field === "out_come_variable") {
      setFuturePlanData({
        ...futurePlanData,
        out_come: output,
      });
    }
  };

  const onChangeOutComePerYear = (e) => {
    if (isNaN(e.target.value)) return;

    const tempValue = e.target.value ? Number(e.target.value) : null;

    // if (tempValue > Number(formRetire?.out_come_peryear_max)) return;
    if (tempValue > 100) return;


    // Set tempValue to the state
    setFormRetire({
      ...formRetire,
      out_come_peryear: tempValue,
      strategy_control_rate_outcome: tempValue,
    });

    setFuturePlanData({
      ...futurePlanData,
      out_come_peryear: tempValue,
    });
  };

  // setFuturePlanData({
  //   ...futurePlanData,
  //   out_come_peryear: formRetire?.out_come_peryear,
  // });

  const onChangeOutComePerYearMax = (e) => {
    if (isNaN(e.target.value)) return;
    if (e.target.value > 300) return;
    else {
      setError({
        ...error,
        out_come_peryear_max: false,
      });
    }
    const value = e.target.value ? Number(e.target.value) : null;

    setFormRetire({
      ...formRetire,
      out_come_peryear: value,
      out_come_peryear_max: value,
    });

    setFuturePlanData({
      ...futurePlanData,
      out_come_peryear_max: value,
    });
  };

  const getResult = () => {
    let result = 0;
    result = formRetire?.salary - formRetire?.out_come;
    return Number(result);
  };

  const onChangeChildEducation = (e) => {
    const value = e.target.value;
    // console.log("value",value)
    setFormRetire({
      ...formRetire,
      ishavekids: value === "high" ? true : false,
    });
    setRetireData({
      ...formRetire,
      ishavekids: value === "high" ? true : false,
    });
  };

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      setFormRetire({
        ...formRetire,
        outcome_remain: getResult(),
      });
    }
  }, [formRetire?.out_come]);

  return (
    <div className={STYLE_SPACE_Y}>
      {userData?.is_premium ? (
        //============================premium========================================
        <>
          <CardMain
            // onClick={() => {
            //   setOpenSalary(true);
            // }}
            icon={false}
            title="รายจ่ายคงที่/เดือน (ไม่รวมเงินผ่อนชำระหนี้สินคงค้างรายงวด) "
            margin=""
            mb="mb-[21px]"
            panel={
              <div className=" px-2">
                <NumericFormat
                  value={Number(formRetire?.out_come || 0)}
                  onChange={onChangeOutCome("out_come")}
                  maxLength={11}
                  placeholder="25,000"
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  className={error?.salary ? STYLE_INPUT_ERROR : STYLE_INPUT}
                />
                {error?.salary && (
                  <ErrorMain errortext="กรุณากรอกรายจ่ายคงที่ ถ้าไม่มีรายจ่ายคงที่กรุณากรอกเลข 0" />
                )}
              </div>
            }
          />
          <CardHeadgray
            title={
              <div>
                {`หนี้สินคงค้าง  `}
                {((balanceData?.debt_long_list?.length <= 0 &&
                  balanceData?.debt_short_list?.length <= 0) ||
                  (!balanceData?.debt_long_list &&
                    !balanceData?.debt_short_list)) && (
                  <span className="font-normal">{`*กรุณากรอก หนี้สิน ที่งบดุล ระบบจะดึงมาคำนวณอัตโนมัติ`}</span>
                )}
              </div>
            }
            text_color="text-mainblue font-semibold text-xl"
            panel={
              <ViewTableDebt
                debtShortList={balanceData?.debt_short_list}
                debtLongList={balanceData?.debt_long_list}
              />
            }
          />
          <CardMain
            // onClick={() => {
            //   setOpenSalary(true);
            // }}
            icon={false}
            title="รายจ่ายแปรผัน/เดือน"
            margin=""
            mb="mb-[21px]"
            panel={
              <div className=" px-2">
                <NumericFormat
                  value={Number(formRetire?.out_come_variable || 0)}
                  onChange={onChangeOutCome("out_come_variable")}
                  maxLength={11}
                  placeholder="0"
                  thousandSeparator=","
                  inputMode="decimal"
                  pattern="[0-9],*"
                  className={
                    error?.out_come_variable ? STYLE_INPUT_ERROR : STYLE_INPUT
                  }
                />
                {error?.out_come_variable && (
                  <ErrorMain errortext="กรุณากรอกรายจ่ายแปรผัน ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
                )}
              </div>
            }
          />
          <CardMain
            // onClick={() => {
            //   setOpenSalaryInfo(true);
            // }}
            icon={false}
            title="อัตรารายจ่ายผันแปรที่เพิ่มขึ้นต่อปี (%)"
            margin=""
            mb="mb-2.5"
            panel={
              <div className=" px-4">
                <div className=" flex justify-center">
                  <NumericFormat
                    maxLength={11}
                    min={1}
                    thousandSeparator=","
                    inputMode="decimal"
                    pattern="[0-9],*"
                    placeholder="0"
                    className={STYLE_INPUT_SLIDER}
                    value={formRetire?.out_come_peryear}
                    onChange={onChangeOutComePerYear}
                  />
                </div>
                <SliderSingle
                  placeholder="0"
                  // valuemax={formRetire?.out_come_peryear_max}
                  value={formRetire?.out_come_peryear}
                  onChange={onChangeOutComePerYear}
                  onChnageMax={onChangeOutComePerYearMax}
                  valuemin={1}
                  valuemax={100}
                  disabledMax={true}
                />
                {error?.salary_peryear && (
                  <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี ถ้าไม่มีเงินเดือนกรุณากรอกเลข 0" />
                )}
                {error?.salary_peryear_max && (
                  <ErrorMain errortext="กรุณากรอกเงินเดือนที่เพิ่มขึ้นต่อปี" />
                )}
              </div>
            }
          />
          <QuestionCard
            name={"one"}
            checkedHigh={formRetire?.ishavekids}
            checkedMedium={!formRetire?.ishavekids}
            // checkedLow={formRisk?.sick_level_pass_away_low}
            formRisk={formRetire?.ishavekids}
            onChange={onChangeChildEducation}
            className=" bg-[#F4F2F3] "
            classNameChoice="justify-start"
            question="คุณสนใจที่จะนำค่าใช้จ่ายเพื่อการศึกษาบุตรมารวมด้วยไหม ?"
            choice1={`ใช่`}
            choice2={`ไม่ใช่`}
          />
          {formRetire?.ishavekids &&
            educationData?.map((item, index) => {
              return (
                <div className="  w-full  ">
                  <CardKidsSection educationItem={item} />
                </div>
              );
            })}
        </>
      ) : (
        //============================Normal========================================
        <>
          <CardMain
            onClick={() => {
              setOpenCurrent(true);
            }}
            icon={false}
            title="รายจ่ายปัจจุบัน (บาท/ต่อเดือน)"
            panel={
              <div className=" px-4">
                {formRetire?.salary ? (
                  <div>
                    <div className=" flex justify-center ">
                      <NumericFormat
                        maxLength={11}
                        className={`${STYLE_INPUT_SLIDER} w-28`}
                        value={Number(formRetire?.out_come || 0)}
                        onChange={onChangeOutCome("out_come")}
                        placeholder="5,000"
                        thousandSeparator=","
                        inputMode="decimal"
                        pattern="[0-9],*"
                      />
                    </div>
                    <div className=" flex gap-[5px] items-center mt-3  ">
                      <div className=" test w-full">
                        <input
                          type="range"
                          min={0}
                          max={formRetire?.salary}
                          value={formRetire?.out_come}
                          onChange={onChangeOutCome("out_come")}
                          step={500}
                        />
                      </div>
                    </div>
                    <div className=" flex justify-between mt-2">
                      <div className=" text-bluegray50 font-semibold text-xl font-IBMPlexSansThai">
                        {0}
                      </div>
                      <div className=" text-bluegray50 font-semibold text-sm font-IBMPlexSansThai">
                        {numeral(formRetire?.salary)?.format("0,0")} บาท
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="flex gap-[5px] items-center ">
                        <div className=" bg-mainyellow  w-[18px] h-[10px] rounded-sm "></div>
                        <div className=" text-sm font-semibold text-mainblue">
                          รายจ่าย :{" "}
                          {numeral(formRetire?.out_come)?.format("0,0")} บาท
                        </div>
                      </div>

                      {getResult() > 0 ? (
                        <div className="flex gap-[5px] items-center ">
                          <div className=" bg-maingreen  w-[18px] h-[10px] rounded-sm "></div>
                          <div
                            className={`text-sm font-semibold  text-mainblue`}
                          >
                            คงเหลือ : {numeral(getResult())?.format("0,0")} บาท
                          </div>
                        </div>
                      ) : (
                        <div className="flex gap-[5px] items-center ">
                          <div className=" bg-mainred  w-[18px] h-[10px] rounded-sm "></div>
                          <div
                            className={`text-sm font-semibold  text-mainred`}
                          >
                            คงเหลือ : {numeral(getResult())?.format("0,0")} บาท
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className=" px-2">
                    <NumericFormat
                      maxLength={11}
                      thousandSeparator=","
                      inputMode="decimal"
                      pattern="[0-9],*"
                      className={
                        error?.out_come ? STYLE_INPUT_ERROR : STYLE_INPUT
                      }
                      placeholder="10,000"
                      value={formRetire?.out_come || 0}
                      onChange={onChangeOutCome("out_come")}
                    />
                    {error?.out_come && (
                      <ErrorMain errortext="กรุณากรอกรายจ่ายปัจจุบัน" />
                    )}
                  </div>
                )}
              </div>
            }
          />
          <CardMain
            onClick={() => {
              setOpenOutCome(true);
            }}
            icon={false}
            title="รายจ่ายที่เพิ่มขึ้นต่อปี (%)"
            margin=""
            mb="mb-4"
            panel={
              <div className=" px-4">
                <div className=" flex justify-center">
                  <NumericFormat
                    type="number"
                    maxLength={11}
                    min={1}
                    placeholder="0"
                    thousandSeparator=","
                    inputMode="decimal"
                    pattern="[0-9],*"
                    className={STYLE_INPUT_SLIDER}
                    value={formRetire?.out_come_peryear}
                    onChange={onChangeOutComePerYear}
                  />
                </div>
                <SliderSingle
                  valuemin={1}
                  // valuemax={formRetire?.out_come_peryear_max}
                  valuemax={100}
                  disabledMax={true}
                  value={formRetire?.out_come_peryear}
                  onChange={onChangeOutComePerYear}
                  onChnageMax={onChangeOutComePerYearMax}
                />
                {error?.out_come_peryear_max && (
                  <ErrorMain errortext="กรุณากรอกรายจ่ายที่เพิ่มขึ้นต่อปี" />
                )}
              </div>
            }
          />
        </>
      )}
    </div>
  );
};

export default ViewIncomeOutcome;
